import React, { useMemo, useRef } from 'react';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import gfm from 'remark-gfm';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import { SOURCE_URL } from '../../../config';

interface SupportSliderProps {
    element: any
}

const SupportSlider: React.FC<SupportSliderProps> = (element) => {
    const swiperRef = useRef<any>(null);

    const swiperConfig = useMemo(() => {
        let config = {
            slidesPerView: 1,
            spaceBetween: 8,
            slidesPerGroup: 1,
            observer: true,
            observeParents: true,
            navigation: {
                nextEl: '.swiper-button-next.slider',
                prevEl: '.swiper-button-prev.slider',
            },
            modules: [Navigation, Pagination, Scrollbar, A11y],
            onSwiper: (swiper: any) => {
                swiperRef.current = swiper;
            },
        }
        return config;
    }, [element?.element?.SliderItem]);

    return (
      <>
        <div className="container-fluid">
            <div className="tab-content">
                <div className="tab-content-wrap active">
                    <div className="spacer-top">
                        <div className="swiper-container support-slider-carousel mx-auto px-sm-5 px-3">
                            <Swiper key={element?.element?.SliderItem} {...swiperConfig}>
                                {element?.element?.SliderItem.map((item: any, index: number) => (
                                    <SwiperSlide key={index}>
                                        <div className="item">
                                            <span className="d-block lg_font_size text-center pb-3">{item?.Title}</span>
                                            <div className="thumbnail-wrap d-block">
                                                    <div className="img-wrap light-gray-bg d-flex align-items-center w-100 p-3">
                                                        <img src={SOURCE_URL + item?.Image?.data?.attributes?.url} className="d-block mx-auto img-fluid" alt="" />
                                                    </div>
                                                    <div className="p-4">
                                                        <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]}>{item?.Description}</ReactMarkdown>
                                                    </div>
                                                </div>
                                        </div>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                            <div className="swiper-button-next slider"></div>
                            <div className="swiper-button-prev slider"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

      </>
    );
};

export default SupportSlider;